import _taggedTemplateLiteral from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import { css as _css } from "styled-components";
import { keyframes as _keyframes } from "styled-components";
import _styled from "styled-components";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["animation: ", " 2s ease-out infinite 0.5s;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  50% {\n    opacity: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import { ReactComponent as FireIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/heatchill/fire.svg";
import { ReactComponent as SnowIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/heatchill/snow-flake.svg";

function circleOffset(props) {
  if (props.indeterminate) {
    return 12;
  }

  if (props.toggled) {
    return 25;
  }

  return -1;
}

var blinkAnimation = _keyframes(_templateObject());

var Circle = _styled.div.withConfig({
  displayName: "HeatChillToggle__Circle",
  componentId: "sc-1spcsnu-0"
})(["position:absolute;left:0px;bottom:-4px;height:33px;width:33px;box-shadow:0px 4px 7px rgba(0,0,0,0.5);border-radius:20px;border:1px solid #a7a8aa;background:white;transition:all ", "s;transform:translateX(", "px);& svg{display:block;position:absolute;top:4px;left:5px;transition:all ", "s;", " &:nth-child(1){opacity:", ";color:var(--state-inactive-color-or,#4d9adf);}&:nth-child(2){opacity:", ";color:var(--state-inactive-color-or,#dd4e4e);}}"], function (p) {
  return p.indeterminate ? 0.15 : 0.3;
}, circleOffset, function (p) {
  return p.indeterminate ? 0.15 : 0.3;
}, function (p) {
  return p.syncing ? _css(_templateObject2(), blinkAnimation) : '';
}, function (p) {
  return p.indeterminate || p.toggled ? 0 : 1;
}, function (p) {
  return p.indeterminate || !p.toggled ? 0 : 1;
});

var ToggledStyled = _styled.button.withConfig({
  displayName: "HeatChillToggle__ToggledStyled",
  componentId: "sc-1spcsnu-1"
})(["position:relative;background-color:#d3d3d3;height:28px;width:60px;border-radius:14px;border:1px solid #eaeaee;transition:all ", "s;outline:none;cursor:", ";& > svg{display:", ";position:absolute;top:5px;width:16px;height:16px;color:#888;&:nth-child(1){left:5px;}&:nth-child(2){left:37px;}}"], function (p) {
  return p.indeterminate ? 0.15 : 0.3;
}, function (p) {
  return p.indeterminate ? "default" : "pointer";
}, function (p) {
  return p.indeterminate ? "none" : "block";
});

export function HeatChillToggle(_ref) {
  var on = _ref.on,
      onChange = _ref.onChange,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      _ref$syncing = _ref.syncing,
      syncing = _ref$syncing === void 0 ? false : _ref$syncing;
  return /*#__PURE__*/React.createElement(ToggledStyled, {
    toggled: on,
    indeterminate: indeterminate,
    onClick: indeterminate ? undefined : onChange
  }, /*#__PURE__*/React.createElement(SnowIcon, null), /*#__PURE__*/React.createElement(FireIcon, null), /*#__PURE__*/React.createElement(Circle, {
    toggled: on,
    indeterminate: indeterminate,
    syncing: syncing
  }, /*#__PURE__*/React.createElement(SnowIcon, null), /*#__PURE__*/React.createElement(FireIcon, null)));
}